import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import SuperAdminExportPresetsView from "../views/SuperAdminExportPresetsView/SuperAdminExportPresetsView";

export default function SuperAdminExportPresets(props) {
	const hasRight = useHasRight();

	if (!hasRight("distribution.admin")) {
		return <Unauthorized />;
	}

	return <SuperAdminExportPresetsView {...props} />;
}
